import React from 'react';
import {
  formatCurrency,
  formatDate,
  formatBankInfoDisplay,
  getApplicationPayee,
  formatNumberStringForExcel
} from '../../../lib/utils';
import {
  ApplicationStatuses,
  CurrencyTypes,
  ManualPaymentTypes,
  RecipientTypes
} from '../../../lib/systemVariables';
import { getRequest, putRequest } from '../../../lib/apiUtils';
import { toastr } from 'react-redux-toastr';

import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import ApplicationActionsDropdown from '../../commonComponents/shared/ApplicationActionsDropdown';
import ExportButton from '../../commonComponents/shared/ExportButton';
import PrintModal from '../../printingComponents/PrintModal';
import CompletePrintingModal from './CompletePrintingModal';
import ApplicationAttachmentModal from './ApplicationAttachmentModal';
import ApplicationAttachmentsUploadModal from './ApplicationAttachmentsUploadModal';
import ApplyToPledgeModal from './ApplyToPledgeModal';
import ApplicationNoteModal from './NoteModal';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import IncompleteApplicationWarning from '../../commonComponents/shared/IncompleteApplicationWarning';
import { PayeeTypes } from '../../../lib/constants';
import MarkInquiryWarning from '../../applicationsComponents/applicationsCommon/MarkInquiryWarning';

export default class ApplicationDetailsCard extends NavigationComponent {
  constructor(props) {
    super(props);

        this.initialState = {
            showHistory: false,
            sendingACH: false,
            showModals: {
                printApplicationsModal: false,
                completePrintingModal: false,
                confirmPrintingModal: false,
                applicationAttachmentModal: false,
                applicationAttachmentsUploadModal: false,
                applicationNoteModal: false,
                deleteNoteConfirmationModal: false,
                revertStatusConfirmationModal: false,
                sendACHConfirmationModal: false,
                applyToPledgeModal: false
            },
            achSendSuccess: false,
            uploadingReceipt: false,
            deletingReceipt: false,
            isDraggingReceipt: false,
            selectedPledgeId: '',
            applyingPledge: false,
            attachment: {
                loading: false,
                success: true,
                document: {}
            },
            receipt: {
                loading: false,
                success: true,
                document: {}
            },
            viewingDocumentType: null, // 'attachment' or 'receipt'
            note: {}
        };

    this.state = this.initialState;
    this.detailsRef = null;
    this.setDetailsRef = element => {
      this.detailsRef = element;
    };
    this.receiptFileInputRef = null;
    this.setReceiptFileInputRef = element => {
      this.receiptFileInputRef = element;
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.applicationDetails.applicationId &&
      nextProps.applicationDetails.applicationId !== this.props.applicationDetails.applicationId
    )
      this.setState(this.initialState);
  }

  async getWireApplicationForExport(applicationId) {
    let application = await this.props.wireApplication([applicationId]);
    if (application.data.length) {
      application.data[0].teudatZahut = formatNumberStringForExcel(application.data[0].teudatZahut);
    }
    return application;
  }

  validForACH() {
    const { recipientDetails, applicationDetails } = this.props;
    const paymentInfo = applicationDetails.paymentInfo;
    const bankAccounts = recipientDetails.bankAccounts || [];

    // Validate ACH eligibility
    if (!paymentInfo.fundAllowsACH || paymentInfo.payTo !== PayeeTypes.Recipient)
    {
      return false;
    }

  // Check for at least one valid ACH-enabled account
  return bankAccounts.some(({ active, achRoutingNumber, achAccountNumber, achAccountType }) =>
    active && achRoutingNumber && achAccountNumber && achAccountType
  );
}

  isOrg() {
    return this.props.applicationDetails.recipient.applicantType === RecipientTypes.Organization;
  }

  async confirmSendACH() {
    const { applicationId, recipientId } = this.props.applicationDetails;
    this.setState({ sendingACH: true, achSendSuccess: false });
    try {
      const response = await this.props.sendACH([applicationId]);

      if (response.success) {
        const applicationResult = response.data
          ? response.data.find(result => result.transactionId === applicationId)
          : null;

        if (applicationResult && applicationResult.isSuccess) {
          toastr.success("ACH Transfer Successful", "The ACH transfer has been initiated successfully.");
          this.setState({ achSendSuccess: true });
          this.props.getApplicationDetails(applicationId, true, recipientId);
          return true;
        } else {
          const errorMessage = applicationResult ? applicationResult.message : "No response received from server";
          toastr.error("ACH Transfer Failed", errorMessage);
          return false;
        }
      } else {
        const errorMessage = response.message || "ACH transfer could not be initiated. Please try again.";
        toastr.error("ACH Transfer Failed", errorMessage);
        return false;
      }
    } catch (error) {
      console.error('ACH Error:', error);
      const errorMessage = error.message || "ACH transfer could not be initiated. Please try again.";
      toastr.error("Something went wrong", errorMessage);
      return false;
    } finally {
      this.setState({ sendingACH: false });
    }
  }

  getApplicationActions(status) {
    const application = this.props.applicationDetails;
    const fund = application.paymentInfo
      ? this.props.funds.find(f => f.key === application.paymentInfo.fundId).value
      : {};
    const applicationActionsDropdown = (
      <ApplicationActionsDropdown
        status={status}
        applicationId={application.applicationId}
        userId={this.props.userId}
        approverId={application.approverId}
        admin={this.props.admin}
        amount={application.amount}
        currency={application.currency}
        inquire={application.inquire}
        inquireNote={application.inquireNote}
        update={this.props.applicationStatusUpdate}
        updateApplicationStatus={async (action, app) => {
          await this.props.updateApplicationStatus(action, app);
          if (this.props.applicationStatusUpdate.success)
            this.props.getApplicationDetails(application.applicationId, true);
        }}
        maxAmount={application.maxApprovalAmount}
      />
    );

        switch (status) {
            case ApplicationStatuses.New:
                return <div>
                    {this.props.permissions.manage &&
                        <button className="btn btn-flat btn-flat-primary"
                            disabled={this.props.disableEditMode}
                            title={this.props.disableEditMode ? "Submit your recipient changes before editing this application." : ""}
                            onClick={this.props.toggleEditMode}>
                            <i className="icon ion-edit icon-left" />Edit
                    </button>}
                    {(this.props.permissions.approveFull || this.props.permissions.approveLimited) && applicationActionsDropdown}
                </div>;
            case ApplicationStatuses.Incomplete:
                return <div>
                    {this.props.permissions.manage &&
                        <button className="btn btn-flat btn-flat-primary" onClick={this.props.toggleEditMode.bind(this)}>
                            <i className="icon ion-edit icon-left" />Edit
                    </button>}
                    {(this.props.admin || this.props.userId === application.approverId) ? applicationActionsDropdown :
                        <button className="btn btn-flat btn-xs btn-flat-status-incomplete">Incomplete</button>}
                </div>;
            case ApplicationStatuses.Approved:
                return <div className="flex">
                    {(this.props.permissions.manage && application.approverId === this.props.userId) &&
                        <button className="btn btn-flat btn-flat-primary" onClick={this.props.toggleEditMode.bind(this)}>
                            <i className="icon ion-edit icon-left" />Edit
                    </button>}
                    {application.currency === CurrencyTypes.Shekel
                        ? (this.props.permissions.wire && <ExportButton
                            text="Wire Payment"
                            busyText="Exporting Wire Info..."
                            disabled={application.amount > fund.wiringMax}
                            title={application.amount > fund.wiringMax ? "Application amount exceeds wiring max" : ""}
                            exportHeaders={[
                                { label: "First Name", value: "firstName", default: "" },
                                { label: "Last Name", value: "lastName", default: "" },
                                { label: "Teudat", value: "teudatZahut", default: "" },
                                { label: "Wire Info", value: "wireInfo", default: "" },
                                { label: "Address", value: "address", default: "" },
                                { label: "City", value: "city", default: "" },
                                { label: "Amount", value: "amount", default: "" },
                                { label: "Pay To", value: "payTo", default: "" },
                                { label: "Currency Symbol", value: "currencySymbol", default: "" }
                            ]}
                            fileName="Approved-wires"
                            getDataForExport={this.getWireApplicationForExport.bind(this, application.applicationId)}
                            onGetDataSuccess={this.props.getApplicationDetails.bind(this, application.applicationId, true, application.recipientId)} />)
                        : (this.props.permissions.print &&
                            (application.printJobId
                                ? <button className="btn btn-flat"
                                    onClick={this.toggleModal.bind(this, 'confirmPrintingModal')}>
                                    <i className="icon-printer icon-left" />Confirm Printing</button>
                                : <div className="flex">
                                    <button className="btn btn-flat" disabled={application.amount > fund.checkCuttingMax}
                                        title={application.amount > fund.checkCuttingMax ? "Application amount exceeds check cutting max" : ""}
                                        onClick={this.toggleModal.bind(this, 'printApplicationsModal')}>
                                        <i className="icon-printer icon-left" />Print</button>
                                    {this.validForACH() && this.isOrg() && <button className="btn btn-flat" 
                                        disabled={application.amount > fund.checkCuttingMax || this.state.sendingACH}
                                        title={application.amount > fund.checkCuttingMax ? "Application amount exceeds check cutting max" : ""}
                                        onClick={this.toggleModal.bind(this, 'sendACHConfirmationModal')}>
                                       <i className="icon-credit-card icon-left" />
                                        {this.state.sendingACH ? 'Sending...' : 'Send ACH'}
                                    </button>}
                                </div>))}
                    {(this.props.permissions.approveFull || this.props.permissions.approveLimited) &&
                        <button className="btn btn-flat btn-flat-accent" onClick={() => this.toggleModal('revertStatusConfirmationModal')}>
                            <i className="icon-action-undo icon-left" />Undo Approval
                    </button>}
                    {(this.props.admin || this.props.userId === application.approverId) ? applicationActionsDropdown :
                        <button className="btn btn-flat btn-xs btn-flat-status-approved">Approved</button>}
                </div>;
            case ApplicationStatuses.InReview:
                return <div>
                    {(this.props.permissions.approveFull || this.props.permissions.approveLimited) &&
                        <button className="btn btn-flat btn-flat-accent" onClick={() => this.toggleModal('revertStatusConfirmationModal')}>
                            <i className="icon-action-undo icon-left" />Undo Review
                    </button>}
                    {(this.props.permissions.approveFull || this.props.permissions.approveLimited) ? applicationActionsDropdown :
                        <button className="btn btn-flat btn-xs btn-flat-status-inreview">In Review</button>}
                </div>;
            case ApplicationStatuses.Paid:
                return <div>
                    {application.clearedMonth ?
                        <button className="btn btn-flat btn-flat-cleared">Cleared {application.clearedMonth}</button>
                        : (this.props.permissions.void &&
                            <button className="btn btn-flat btn-void" onClick={async () => {
                                await this.props.voidPayment([application.applicationId]);
                                if (this.props.voidingPayment.success)
                                    this.props.getApplicationDetails(application.applicationId, true, application.recipientId);
                            }}>
                                {this.props.voidingPayment.loading ? 'Voiding...' : 'Void'}</button>)}
                    {(this.props.admin || this.props.userId === application.approverId) ? applicationActionsDropdown :
                        <button className="btn btn-flat btn-xs btn-flat-status-paid">Paid</button>}
                </div>;
            case ApplicationStatuses.Rejected:
                return <div>
                    {(this.props.permissions.approveFull || this.props.permissions.approveLimited) &&
                        <button className="btn btn-flat btn-flat-accent" onClick={() => this.toggleModal('revertStatusConfirmationModal')}>
                            <i className="icon-action-undo icon-left" />Undo Rejection
                    </button>}
                    {(this.props.admin || this.props.userId === application.approverId) ? applicationActionsDropdown :
                        <button className="btn btn-flat btn-xs btn-flat-status-rejected">Rejected</button>}
                </div>;
            default:
                return null;
        }
    }

  navigateToApplication(applicationId) {
    if (!applicationId) return;
    this.props.selectApplication(applicationId);
    const detailsNode = this.detailsRef;
    if (detailsNode) {
      const position = detailsNode.getBoundingClientRect();
      window.scrollTo({ behavior: 'smooth', left: position.left, top: position.top });
    }
  }

  viewAttachment(document) {
    this.setState(
      { 
        attachment: { success: true, loading: true, document: { ...document, source: '' } },
        receipt: { loading: false, success: true, document: {} },
        viewingDocumentType: 'attachment'
      },
      async () => {
        this.toggleModal('applicationAttachmentModal');
        const res = await getRequest(
          `/applications/${this.props.applicationDetails.applicationId}/attachments/${document.documentId}`,
          null,
          null,
          { responseType: 'arraybuffer' }
        );
        this.setState({
          attachment: {
            success: res.success,
            loading: false,
            document: {
              ...this.state.attachment.document,
              source: res.data
            }
          }
        });
      }
    );
  }

  viewReceipt(document) {
    this.setState(
      { 
        receipt: { success: true, loading: true, document: { ...document, source: '' } },
        attachment: { loading: false, success: true, document: {} },
        viewingDocumentType: 'receipt'
      },
      async () => {
        this.toggleModal('applicationAttachmentModal');
        const res = await getRequest(
          `/applications/${this.props.applicationDetails.applicationId}/receipts/${document.documentId}`,
          null,
          null,
          { responseType: 'arraybuffer' }
        );
        this.setState({
          receipt: {
            success: res.success,
            loading: false,
            document: {
              ...this.state.receipt.document,
              source: res.data
            }
          }
        });
      }
    );
  }

  handleReceiptFileSelect = async (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      // Only take the first file (only one receipt allowed)
      const file = files[0];
      this.setState({ uploadingReceipt: true });
      
      await this.props.updateReceipts(this.props.applicationDetails.applicationId, {
        newReceipts: [file],
        deletedReceipts: []
      });

      // Reset the file input
      if (this.receiptFileInputRef) {
        this.receiptFileInputRef.value = '';
      }

      this.setState({ uploadingReceipt: false });

      // Check for errors and refresh application details
      if (this.props.updatingReceipts.success) {
        await this.props.getApplicationDetails(this.props.applicationDetails.applicationId, true);
      } else {
        toastr.error('Upload failed', this.props.updatingReceipts.message || 'We were unable to upload the receipt. Please try again.');
      }
    }
  }

  handleAddReceiptClick = () => {
    if (this.receiptFileInputRef) {
      this.receiptFileInputRef.click();
    }
  }

  handleDeleteReceipt = async (event, receipt) => {
    if (event) {
      event.stopPropagation(); // Prevent triggering the view receipt click
      event.preventDefault();
    }
    
    const receiptId = receipt.documentId || receipt.fileId || receipt.fileid;
    if (!receiptId) {
      console.error('No receipt ID found:', receipt);
      return;
    }

    this.setState({ deletingReceipt: true });

    try {
      await this.props.deleteReceipt(this.props.applicationDetails.applicationId, receiptId);

      // Check for errors and refresh application details
      if (this.props.updatingReceipts.success) {
        await this.props.getApplicationDetails(this.props.applicationDetails.applicationId, true);
      } else {
        toastr.error('Delete failed', this.props.updatingReceipts.message || 'We were unable to delete the receipt. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting receipt:', error);
      toastr.error('Something went wrong', 'We were unable to delete the receipt. Please try again.');
    } finally {
      this.setState({ deletingReceipt: false });
    }
  }

  handleReceiptDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ isDraggingReceipt: true });
  }

  handleReceiptDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Only set to false if leaving the drop zone entirely
    if (event.currentTarget && !event.currentTarget.contains(event.relatedTarget)) {
      this.setState({ isDraggingReceipt: false });
    }
  }

  handleReceiptDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  }

  handleReceiptDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ isDraggingReceipt: false });

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      
      // Validate file type
      const acceptedTypes = ['application/pdf', 'text/html', 'image/png', 'image/jpeg', 'image/tiff', 'image/gif', 'image/bmp'];
      if (!acceptedTypes.includes(file.type)) {
        toastr.error('Invalid file type', 'Please upload a PDF, HTML, or image file.');
        return;
      }

      this.setState({ uploadingReceipt: true });
      
      await this.props.updateReceipts(this.props.applicationDetails.applicationId, {
        newReceipts: [file],
        deletedReceipts: []
      });

      this.setState({ uploadingReceipt: false });

      // Check for errors and refresh application details
      if (this.props.updatingReceipts.success) {
        await this.props.getApplicationDetails(this.props.applicationDetails.applicationId, true);
      } else {
        toastr.error('Upload failed', this.props.updatingReceipts.message || 'We were unable to upload the receipt. Please try again.');
      }
    }
  }

  showApplicationReasonDate(reason, reasonDate) {
    //Only shows Application Reason Date(wedding date) in case of wedding (Wedding Date)
    if (this.isWedding(reason.reason) && reasonDate) {
      let rDate = new Date(Date.parse(reasonDate));
      const localeFormattedDate = this.props.recipientDetails.isIsraeli
        ? rDate.toLocaleDateString('he-IL')
        : rDate.toLocaleDateString('en-us');

      return ' (' + localeFormattedDate + ')';
    }

    return '';
  }

  isWedding(reason) {
    return reason.toLowerCase().includes('wedding');
  }

  closeApplyToPledgeModal = () => {
    this.setState(prevState => ({
      selectedPledgeId: '',
      applyingPledge: false,
      showModals: {
        ...prevState.showModals,
        applyToPledgeModal: false
      }
    }));
  }

  applyPledgeToApplication = async () => {
    const { selectedPledgeId } = this.state;
    const { applicationDetails } = this.props;

    if (!selectedPledgeId) {
      toastr.error('Pledge required', 'Please select a pledge to apply.');
      return;
    }

    this.setState({ applyingPledge: true });

    try {
      const response = await putRequest(
        `/applications/${applicationDetails.applicationId}/pledge/${selectedPledgeId}`
      );

      if (response.success) {
        await this.props.getApplicationDetails(
          applicationDetails.applicationId,
          true,
          applicationDetails.recipientId
        );
        this.closeApplyToPledgeModal();
        toastr.success('Pledge Applied', 'The selected pledge was applied to the application.');
      } else {
        toastr.error(
          'Unable to apply pledge',
          response.message || 'Please try again.'
        );
      }
    } catch (error) {
      toastr.error('Unable to apply pledge', error.message || 'Please try again.');
    } finally {
      this.setState({ applyingPledge: false });
    }
  }

  render() {
    const {
      amount,
      applicationId,
      approvalNote,
      approverName,
      attachments = [],
      receipts = [],
      campaign,
      campaignIndividualCategory,
      card,
      checkOrWireNumber,
      checkOrWireDate,
      createdBy,
      currency,
      history = [],
      isBlocked,
      isPrivate,
      notes = [],
      paymentInfo = {},
      printInstructions,
      printJobId,
      reason = {},
      reasonDate = {},
      recipientId,
      source = {},
      rejectReason,
      requestedAmount,
      reviewDate,
      signatureNeeded,
      status,
      inquire,
      inquireNote,
      approverId,
      applicantPledge,
      applicantPledgeId,
      weddingHall,
      weddingSide,
      createdDate
    } = this.props.applicationDetails;

    const applicationHistory = history
      .slice()
      .sort((r1, r2) => r2.applicationHistoryId - r1.applicationHistoryId);
    const payeeIsIsraeli = getApplicationPayee(
      this.props.applicationDetails.paymentInfo,
      this.props.recipientDetails
    ).isIsraeli; //Need to get payee to set currency type for request amount display and input - because that reflects nationlity of payee, and does not necessarily match the currency type of the application - if the application is paid with manual check.
    const incompleteFields =
      applicationId && status === ApplicationStatuses.Incomplete
        ? this.props.getIncompleteFields()
        : null;
    const applicantPledgeOptions = (this.props.recipientDetails.applicantPledges || []).map(p => ({
      key: p.applicantPledgeId,
      value: `#${p.applicantPledgeId} - ${formatDate(p.pledgeDate)} - ${formatCurrency(p.pledgeAmount)}`
    }));

    return (
      <div className="details-card card">
        {isBlocked ? (
          <div ref={this.setDetailsRef} className="details-card-header flex-justify flex-center">
            <label className="input-label">Private Application by {createdBy}</label>
          </div>
        ) : (
          <div ref={this.setDetailsRef} className="details-card-header flex-justify flex-center">
            <label className="input-label">Details</label>
            {this.getApplicationActions(status)}
          </div>
        )}
        {!isBlocked &&
          (applicationId || this.props.loading) &&
          (this.props.loading ? (
            <LoadingSpinner height="20" />
          ) : (
            <div>
              <div className="details-card-subheader flex-justify">
                <div>
                  {inquire && <MarkInquiryWarning inquireNote={inquireNote} />}

                  {incompleteFields && (
                    <IncompleteApplicationWarning viewOnly={true} fields={incompleteFields} />
                  )}
                  <div>
                    {!!(
                      status === ApplicationStatuses.Approved ||
                      status === ApplicationStatuses.Paid ||
                      (campaign && amount)
                    ) && <h6>{formatCurrency(amount, currency === CurrencyTypes.Shekel)}</h6>}
                    {status === ApplicationStatuses.Paid &&
                      ((paymentInfo.manualPayment && paymentInfo.manualPayment.manualPaymentType) ||
                        checkOrWireNumber ||
                        checkOrWireDate) && (
                        <p className="small-text accent-text">
                          {paymentInfo.manualPayment &&
                          paymentInfo.manualPayment.manualPaymentType ===
                            ManualPaymentTypes.ManualWire
                            ? 'Wire'
                            : 'Check'}{' '}
                          #{checkOrWireNumber}{' '}
                          {checkOrWireDate ? '| ' + formatDate(checkOrWireDate) : ''}
                        </p>
                      )}
                  </div>
                  <h6>
                    {campaign
                      ? campaign
                      : reason && reason.reason
                      ? reason.reason +
                        ' ' +
                        (this.showApplicationReasonDate(reason, reasonDate) || '')
                      : ''}
                    {reason && reason.reason && this.isWedding(reason.reason) && (
                      <div className="flex-center">
                        <p className="small-text" style={{ marginRight: '8px' }}>
                          <span className="accent-text">Wedding Hall: </span>
                          {weddingHall}
                        </p>
                        <p className="small-text">
                          <span className="accent-text">Side: </span>
                          {weddingSide}
                        </p>
                      </div>
                    )}
                  </h6>
                  <div className="flex-center">
                    {campaignIndividualCategory && (
                      <p className="accent-text bold-text" style={{ marginRight: '8px' }}>
                        {campaignIndividualCategory}
                      </p>
                    )}
                    {paymentInfo.fundName && (
                      <p className="accent-text3 uppercase-text small-text bold-text">
                        {paymentInfo.fundName}
                      </p>
                    )}
                  </div>
                </div>
                {isPrivate && (
                  <p className="accent-text medium-text private light-text">
                    <i className="icon ion-ios-locked-outline" />
                    Private
                  </p>
                )}
              </div>
              <div className="details-card-section details-card-section-icons">
                {requestedAmount > 0 && (
                  <p className="small-text">
                    <i className="icon-wallet accent-text2" />{' '}
                    <span className="accent-text">Requested Amount:</span>{' '}
                    {formatCurrency(requestedAmount, payeeIsIsraeli)}
                  </p>
                )}
                <p className="small-text">
                  <i className="icon-credit-card accent-text2" />{' '}
                  <span className="accent-text">Payable to: </span>
                  {paymentInfo.payTo === PayeeTypes.Recipient
                    ? 'Recipient'
                    : paymentInfo.payTo === PayeeTypes.TrustedPayee
                    ? ` Trusted Payee: ${paymentInfo.trustedPayeePayment.paidToName} -
                                        ${formatBankInfoDisplay(
                                          paymentInfo.trustedPayeePayment.bankNumber,
                                          paymentInfo.trustedPayeePayment.branchNumber,
                                          paymentInfo.trustedPayeePayment.accountNumber,
                                          paymentInfo.trustedPayeePayment.accountHolder
                                        )}`
                    : paymentInfo.thirdParty
                    ? `${
                        paymentInfo.thirdParty.orgName ||
                        `${paymentInfo.thirdParty.firstName || ''} ${
                          paymentInfo.thirdParty.lastName || ''
                        }`
                      }
                                                ${
                                                  paymentInfo.thirdParty.bankNumber ||
                                                  paymentInfo.thirdParty.branchNumber ||
                                                  paymentInfo.thirdParty.accountNumber ||
                                                  paymentInfo.thirdParty.accountHolder
                                                    ? ` - ${formatBankInfoDisplay(
                                                        paymentInfo.thirdParty.bankNumber,
                                                        paymentInfo.thirdParty.branchNumber,
                                                        paymentInfo.thirdParty.accountNumber,
                                                        paymentInfo.thirdParty.accountHolder
                                                      )}`
                                                    : ''
                                                }
                                                ${
                                                  paymentInfo.thirdParty.useRecipientAddress
                                                    ? " at recipient's address"
                                                    : paymentInfo.thirdParty.addressDisplay
                                                    ? ` - ${paymentInfo.thirdParty.addressDisplay}`
                                                    : ''
                                                }
                                                ${
                                                  paymentInfo.thirdParty.careOf
                                                    ? ` | Care Of: ${paymentInfo.thirdParty.careOf}`
                                                    : ''
                                                }`
                    : ''}
                </p>
                {status === ApplicationStatuses.Incomplete &&
                  paymentInfo.manualPayment &&
                  paymentInfo.manualPayment.manualPaymentType && (
                    <p className="small-text">
                      <i /> <span className="accent-text">Manual Payment: </span>
                      {paymentInfo.manualPayment.manualPaymentNumber
                        ? `#${paymentInfo.manualPayment.manualPaymentNumber}`
                        : ''}{' '}
                      {paymentInfo.manualPayment.manualPaymentDate
                        ? formatDate(paymentInfo.manualPayment.manualPaymentDate)
                        : ''}{' '}
                      {paymentInfo.manualPayment.manualPaymentAmount
                        ? formatCurrency(
                            paymentInfo.manualPayment.manualPaymentAmount,
                            currency === CurrencyTypes.Shekel
                          )
                        : ''}
                    </p>
                  )}
              </div>
              <div className="details-card-section details-card-section-icons">
                {approverName && (
                  <p className="small-text">
                    <i className="icon-user accent-text2" />{' '}
                    <span className="accent-text">Approver:</span> {approverName}
                  </p>
                )}
                {source && source.referenceId && (
                  <p className="small-text">
                    <i className="icon ion-ios-people-outline accent-text2" />{' '}
                    <span className="accent-text">Source: </span> <span>{source.name}</span>
                    {(source.address || source.email || source.phoneNumber) && (
                      <span>
                        {' '}
                        -{' '}
                        {[source.address, source.email, source.phoneNumber]
                          .filter(i => i)
                          .join(' - ')}
                      </span>
                    )}
                  </p>
                )}
              </div>
              <div className="details-card-section details-card-section-icons">
                {paymentInfo.checkMemo && (
                  <p className="small-text">
                    <i className="icon-doc accent-text2" />{' '}
                    <span className="accent-text">Check Memo: </span> {paymentInfo.checkMemo}
                  </p>
                )}
                {paymentInfo.reportMemo && (
                  <p className="small-text">
                    <i className="icon-doc accent-text2" />{' '}
                    <span className="accent-text">Report Memo: </span> {paymentInfo.reportMemo}
                  </p>
                )}
                {(card || printInstructions || signatureNeeded) && (
                  <p className="small-text">
                    <i className="icon-printer accent-text2 left" />
                    <span className="accent-text">Printing Instructions: </span>
                    {card ? `Card - ${card}` : ''}
                    {card && printInstructions ? '.  ' : ''}
                    {printInstructions || ''}
                    {signatureNeeded && (
                      <span className="icon-right error-text small-text">Signature Needed</span>
                    )}
                  </p>
                )}
                {approvalNote && (
                  <p className="small-text">
                    <i className="icon-close accent-text2" />{' '}
                    <span className="accent-text">Approval Note: </span> {approvalNote}
                  </p>
                )}
                {rejectReason && (
                  <p className="small-text">
                    <i className="icon-close accent-text2" />{' '}
                    <span className="accent-text">Rejection Reason: </span> {rejectReason}
                  </p>
                )}
                {reviewDate && (
                  <p className="small-text">
                    <i className="icon-calendar accent-text2" />{' '}
                    <span className="accent-text">Review Date: </span> {formatDate(reviewDate)}
                  </p>
                )}
                {(this.props.recipientDetails.applicantPledges || []).length > 0 && (
                  <p className="small-text">
                    <i className="icon-wallet accent-text2" />{' '}
                    <span className="accent-text">Applied to Pledge:</span>{' '}
                    {applicantPledgeId ? (
                      <span className="bold-text">#{applicantPledgeId}</span>
                    ) : (
                      this.props.permissions.manage && (
                        <button className="btn btn-flat btn-flat-primary btn-xs" onClick={this.toggleModal.bind(this, 'applyToPledgeModal')}>
                          Apply to Pledge
                        </button>
                      )
                    )}
                    {applicantPledgeId && ' '}
                    {applicantPledge}
                  </p>
                )}
              </div>
              <div className="details-card-section">
                <div className="flex-justify">
                  <p className="small-text">
                    <i className="icon-paper-clip accent-text2" />{' '}
                    <span className="accent-text">Attachments: </span>
                  </p>
                  {this.props.permissions.manage && (
                    <p
                      className="xs-text link-text"
                      onClick={this.toggleModal.bind(this, 'applicationAttachmentsUploadModal')}
                    >
                      Add{attachments.length > 0 ? '/Manage' : ''} Attachments
                    </p>
                  )}
                </div>
                {attachments.length > 0 && (
                  <div className="details-card-rows details-card-attachments">
                    {attachments.map(a => (
                      <span
                        key={a.documentId}
                        className="small-text details-card-attachment primary-hover"
                        onClick={this.viewAttachment.bind(this, a)}
                      >
                        {a.extension && a.extension.toLowerCase() === '.docx'
                          ? <i className="material-icons docx-attachment-icon" title="Word document">description</i>
                          : <i className="icon-paper-clip" />}
                        {a.name}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              {(status === ApplicationStatuses.Paid || receipts.length > 0) && (
                <div className="details-card-section">
                  <div className="flex-justify">
                    <p className="small-text">
                      <i className="icon-doc accent-text2" />{' '}
                      <span className="accent-text">Receipt: </span>
                    </p>
                    {this.props.permissions.manage && this.state.deletingReceipt && (
                      <p className="xs-text accent-text">Deleting...</p>
                    )}
                  </div>
                  {receipts.length > 0 ? (
                    <div className="details-card-rows details-card-attachments">
                      {receipts.map(r => {
                        const receiptId = r.documentId || r.fileId || r.fileid;
                        return (
                          <span
                            key={receiptId}
                            className="small-text details-card-attachment primary-hover"
                          >
                            <i className="icon-doc" />
                            <span onClick={this.viewReceipt.bind(this, { ...r, documentId: receiptId })}>
                              {r.name}
                            </span>
                            {this.props.permissions.manage && (
                              <span
                                onClick={(e) => this.handleDeleteReceipt(e, { ...r, documentId: receiptId })}
                                style={{ marginLeft: '8px', cursor: 'pointer', display: 'inline-block' }}
                              >
                                <i className="icon ion-ios-close-outline trash-hover icon-right" />
                              </span>
                            )}
                          </span>
                        );
                      })}
                    </div>
                  ) : (
                    this.props.permissions.manage && (
                      <div
                        className="upload-box"
                        onDragEnter={!this.state.uploadingReceipt ? this.handleReceiptDragEnter : undefined}
                        onDragLeave={!this.state.uploadingReceipt ? this.handleReceiptDragLeave : undefined}
                        onDragOver={!this.state.uploadingReceipt ? this.handleReceiptDragOver : undefined}
                        onDrop={!this.state.uploadingReceipt ? this.handleReceiptDrop : undefined}
                        onClick={!this.state.uploadingReceipt ? this.handleAddReceiptClick : undefined}
                        style={{ marginTop: '8px', cursor: this.state.uploadingReceipt ? 'default' : 'pointer' }}
                      >
                        {this.state.uploadingReceipt ? (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LoadingSpinner height="16" />
                            <span className="accent-text" style={{ marginLeft: '8px' }}>Uploading receipt...</span>
                          </div>
                        ) : (
                          <p className="accent-text">
                            <i className="icon ion-ios-cloud-upload-outline" />
                            Drop files here or <br /> click to <span className="accent-text2 block">Upload Receipt</span>
                          </p>
                        )}
                      </div>
                    )
                  )}
                  {this.props.permissions.manage && (
                    <input
                      ref={this.setReceiptFileInputRef}
                      type="file"
                      style={{ display: 'none' }}
                      accept="application/pdf,text/html,image/png,image/jpeg,image/tiff,image/gif,image/bmp"
                      onChange={this.handleReceiptFileSelect}
                    />
                  )}
                </div>
              )}
              <div className="details-card-section">
                <div className="flex-justify">
                  <p className="small-text">
                    <i className="icon-notebook accent-text2" />{' '}
                    <span className="accent-text">Notes: </span>
                  </p>
                  {this.props.permissions.manage && (
                    <p
                      className="xs-text link-text"
                      onClick={this.toggleModal.bind(this, 'applicationNoteModal')}
                    >
                      Add New
                    </p>
                  )}
                </div>
                <div className="details-card-rows details-card-notes">
                  {notes.map(note => (
                    <div key={note.noteId} className="details-card-note">
                      <p className="medium-text">{note.text}</p>
                      <p className="accent-text small-text">
                        {note.writtenBy} on {formatDate(note.writtenOn)}
                      </p>
                      {(note.userId === this.props.userId || approverId === this.props.userId) && (
                        <div className="details-card-note-actions">
                          <i
                            className="icon-pencil primary-hover icon-right accent-text input"
                            onClick={() => {
                              this.setState({ note });
                              this.toggleModal('applicationNoteModal');
                            }}
                          ></i>
                          <i
                            className="icon-trash trash-hover icon-right accent-text input"
                            onClick={() => {
                              this.setState({ note });
                              this.toggleModal('deleteNoteConfirmationModal');
                            }}
                          ></i>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              {applicationHistory.length > 0 && (
                <div className="details-card-section">
                  <div className="flex-justify">
                    <p className="small-text">
                      <i className="icon-clock accent-text2" />
                      <span className="accent-text">History: </span>
                    </p>
                    {applicationHistory.length > 1 && (
                      <p
                        className="xs-text link-text"
                        onClick={() => this.setState({ showHistory: !this.state.showHistory })}
                      >
                        {this.state.showHistory ? 'Show Less' : 'Show More'}
                      </p>
                    )}
                  </div>
                  <div className="details-card-rows">
                    <div className="flex">
                      <p className="column-quarter small-text">
                        {applicationHistory[0].action} By:
                      </p>
                      <p className="column-quarter small-text">{applicationHistory[0].usersName}</p>
                      <p className="column-quarter small-text">
                        {formatDate(applicationHistory[0].date)}
                      </p>
                      {applicationHistory[0].action === 'Voided' &&
                        applicationHistory[0].checkOrWireNumber && (
                          <p className="column-quarter small-text">{`${
                            applicationHistory[0].transactionSource.includes('Wire')
                              ? 'Wire'
                              : 'Check'
                          }# ${applicationHistory[0].checkOrWireNumber}`}</p>
                        )}
                    </div>
                    {applicationHistory.length > 1 &&
                      this.state.showHistory &&
                      applicationHistory.slice(1, applicationHistory.length).map(record => (
                        <div key={record.applicationHistoryId} className="flex">
                          <p className="column-quarter small-text">{record.action} By:</p>
                          <p className="column-quarter small-text">{record.usersName}</p>
                          <p className="column-quarter small-text">{formatDate(record.date)}</p>
                          {record.action === 'Voided' && record.checkOrWireNumber && (
                            <p className="column-quarter small-text">{`${
                              record.transactionSource.includes('Wire') ? 'Wire' : 'Check'
                            }# ${record.checkOrWireNumber}`}</p>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )}
              <div className="details-card-footer clearfix text-right">
                <div className="flex-center previous-next-arrows">
                  <p
                    className="previous"
                    onClick={this.navigateToApplication.bind(this, this.props.prevApplicationId)}
                  >
                    <i
                      className={`icon ion-ios-arrow-back accent-text2 ${
                        !this.props.prevApplicationId ? 'disabled' : ''
                      }`}
                    />
                    <span
                      className={`link-text ${!this.props.prevApplicationId ? 'disabled' : ''}`}
                    >
                      Previous
                    </span>
                  </p>
                  <p className="accent-text medium-text">
                    {this.props.applicationIndex} of {this.props.totalApplications}
                  </p>
                  <p
                    className="next"
                    onClick={this.navigateToApplication.bind(this, this.props.nextApplicationId)}
                  >
                    <span
                      className={`link-text ${!this.props.nextApplicationId ? 'disabled' : ''}`}
                    >
                      Next
                    </span>
                    <i
                      className={`icon ion-ios-arrow-forward accent-text2 ${
                        !this.props.nextApplicationId ? 'disabled' : ''
                      }`}
                    />
                  </p>
                </div>
              </div>
            </div>
          ))}

        {this.state.showModals.printApplicationsModal && (
          <PrintModal
            close={this.toggleModal.bind(this, 'printApplicationsModal')}
            onPrintSuccess={this.toggleModal.bind(this, 'completePrintingModal')}
            count={1}
            print={printerId =>
              this.props.printCheck('applications', printerId, {
                applicationIds: [this.props.applicationDetails.applicationId]
              })
            }
          />
        )}

        <CompletePrintingModal
          show={
            this.state.showModals.completePrintingModal ||
            this.state.showModals.confirmPrintingModal
          }
          close={this.toggleModal.bind(
            this,
            this.state.showModals.completePrintingModal
              ? 'completePrintingModal'
              : 'confirmPrintingModal'
          )}
          printInfo={
            this.state.showModals.completePrintingModal
              ? this.props.printing.data
              : [
                  {
                    printJobId,
                    checkOrWireNumber,
                    card
                  }
                ]
          }
          allowReprint={this.state.showModals.completePrintingModal}
          reprint={() =>
            this.props.printCheck('reprints', this.props.printing.printerId, {
              printJobIds: [this.props.printing.data[0].printJobId]
            })
          }
          reprinting={this.props.printing}
          confirmPrint={async isCancel => {
            const printInfo = this.state.showModals.completePrintingModal
              ? this.props.printing.data[0]
              : { printJobId };

            await this.props.confirmPrinting([printInfo.printJobId], isCancel);

            if (this.props.confirmingPrinting.success)
              this.props.getApplicationDetails(applicationId, true, recipientId);
          }}
          confirming={this.props.confirmingPrinting}
        />

        <ApplicationAttachmentModal
          show={this.state.showModals.applicationAttachmentModal}
          close={() => {
            this.setState({ 
              attachment: { loading: false, success: true, document: {} }, 
              receipt: { loading: false, success: true, document: {} },
              viewingDocumentType: null
            });
            this.toggleModal('applicationAttachmentModal');
          }}
          {...(this.state.viewingDocumentType === 'receipt' ? this.state.receipt : this.state.attachment)}
          recipient={this.props.recipientDetails}
          documentType={this.state.viewingDocumentType}
        />

        <ApplicationAttachmentsUploadModal
          show={this.state.showModals.applicationAttachmentsUploadModal}
          close={this.toggleModal.bind(this, 'applicationAttachmentsUploadModal')}
          attachments={attachments}
          applicationId={applicationId}
          updateAttachments={this.props.updateAttachments}
          {...this.props.updatingAttachments}
        />


        <ApplicationNoteModal
          show={this.state.showModals.applicationNoteModal}
          close={() => {
            this.setState({ note: {} });
            this.toggleModal('applicationNoteModal');
          }}
          note={this.state.note}
          save={text =>
            this.state.note.noteId
              ? this.props.updateNote(applicationId, this.state.note.noteId, text)
              : this.props.addNote(applicationId, text)
          }
          loading={this.props.updatingNote.loading}
          success={this.props.updatingNote.success}
        />

        <ConfirmationModal
          show={this.state.showModals.deleteNoteConfirmationModal}
          close={() => {
            this.setState({ note: {} });
            this.toggleModal('deleteNoteConfirmationModal');
          }}
          message="Are you sure you want to permanently delete this note?"
          confirm={this.props.deleteNote.bind(this, applicationId, this.state.note.noteId)}
          loading={this.props.updatingNote.loading}
          success={this.props.updatingNote.success}
        />

        <ConfirmationModal
          show={this.state.showModals.revertStatusConfirmationModal}
          close={() => this.toggleModal('revertStatusConfirmationModal')}
          message="Are you sure you want to revert the status of this application to new?"
          confirm={async () => {
            await this.props.revertApplicationStatus(applicationId);
            if (this.props.applicationStatusUpdate.success)
              this.props.getApplicationDetails(applicationId, true);
          }}
          loading={this.props.applicationStatusUpdate.loading}
          success={this.props.applicationStatusUpdate.success}
        />

        <ConfirmationModal
          show={this.state.showModals.sendACHConfirmationModal}
          title="Send ACH"
          message={`Are you sure you want to send ACH to ${
            this.props.recipientDetails && this.props.recipientDetails.displayName
              ? this.props.recipientDetails.displayName
              : "this recipient"
          }?`}
          close={() => this.toggleModal('sendACHConfirmationModal')}
          confirm={this.confirmSendACH.bind(this)}
          loading={this.state.sendingACH}
          success={this.state.achSendSuccess}
          errorMessage="ACH transfer could not be initiated. Please try again."
        />

        <ApplyToPledgeModal
          show={this.state.showModals.applyToPledgeModal}
          close={this.closeApplyToPledgeModal}
          applicantPledgeOptions={applicantPledgeOptions}
          selectedPledgeId={this.state.selectedPledgeId}
          onPledgeChange={e => this.setState({ selectedPledgeId: e.target.value })}
          applyingPledge={this.state.applyingPledge}
          onApply={this.applyPledgeToApplication}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/ApplicationDetailsCard.jsx